import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  afterStyle,
  beforeStyle,
  containerStyle
} from '@/components/ProfileData/Birthday/styles.ts';
import { WheelBirthdaySelectModal } from '@/components/ProfileData/Birthday/WheelBirthdaySelectModal.tsx';
import { InputContent } from '@/components/common/InputContent/InputContent.tsx';
import ArrowRightShape from '@/components/common/svg/shapes/ArrowRightShape.tsx';
import Modal from '@/animations/Modal.tsx';

export const BirthdayTrigger: FC<{
  birthday?: string;
  updateFields: (fields: Partial<{ birthday: string }>) => void;
}> = ({ birthday, updateFields }) => {
  const { t } = useTranslation();

  const [birthdayWheelOpen, setBirthdayWheelOpen] = useState(false);
  const [isOpening, setIsOpening] = useState(false);

  const closeBirthdayWheel = () => setBirthdayWheelOpen(false);

  const openBirthdayWheel = () => {
    setIsOpening(true);
    setTimeout(() => {
      setBirthdayWheelOpen(true);
      setIsOpening(false);
    }, 50);
  };

  return (
    <>
      <InputContent
        title={t('age_section').toUpperCase()}
        footer={t('validation.age')}
        style={{ marginTop: '24px' }}
        styleTitle={{ fontWeight: 510, fontSize: 12, color: '#787878' }}
      >
        <div
          style={containerStyle}
          onClick={!isOpening ? openBirthdayWheel : undefined}
        >
          <div style={{ display: 'flex', flexGrow: 1, alignItems: 'center' }}>
            <div style={beforeStyle}>{t('date_of_birth_title')}</div>
            {birthday && <div style={afterStyle}>{birthday}</div>}
          </div>
          <ArrowRightShape width={14} height={14} />
        </div>
      </InputContent>
      <Modal open={birthdayWheelOpen} handleClose={closeBirthdayWheel}>
        <WheelBirthdaySelectModal
          birthday={birthday}
          updateFields={updateFields}
          handleClose={closeBirthdayWheel}
        />
      </Modal>
    </>
  );
};
